import TreeItem from 'apollo-react/components/TreeItem';
import TreeView from 'apollo-react/components/TreeView';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchDocumentRepositoryDetails } from '../../actions/DocumentRepositoryActions';
import withTranslation from '../withTranslation';

const DocumentRepositoryTree = ({ repositoryName = '', onSelectItem, translateString }) => {
  const dispatch = useDispatch();
  const documentRepository = useSelector((state) => state.documentRepository);
  const { documentRepositoryDetails = {} } = documentRepository;

  const [expanded, setExpanded] = useState([]);

  const mapRepositoryDetails = (parentNode) => (acc, item) => {
    item.parentNode = parentNode;
    return {
      ...acc,
      [item.NodeId]: item,
      ...item.ChildNodes.reduce(mapRepositoryDetails(item), {}),
    };
  };

  const repositoryChildNodes = documentRepositoryDetails.ChildNodes || [];

  const repositoryItems = useMemo(() => {
    const [rootNode] = repositoryChildNodes;
    if (rootNode) {
      setExpanded([rootNode.NodeId]);
    }
    return repositoryChildNodes.reduce(mapRepositoryDetails(), {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentRepositoryDetails]);

  useEffect(() => {
    if (repositoryName) {
      dispatch(fetchDocumentRepositoryDetails({ repositoryName }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [repositoryName]);

  const getSelectedItemPath = (node) => {
    const path = [node.NodeText];

    let parent = node.parentNode;

    while (parent !== undefined) {
      path.push(parent.NodeText);
      parent = parent.parentNode;
    }

    return path.reverse();
  };

  const selectRepositoryItem = (node) => {
    const { NodeId: nodeId, NodeText: nodeText } = node;
    onSelectItem({ nodeText, nodeId }, getSelectedItemPath(node));
  };

  const handleSelect = (_, nodeId) => selectRepositoryItem(repositoryItems[nodeId]);

  const handleExpandedNodes = (_, nodeIds) => setExpanded(nodeIds);

  function renderTreeItems(node) {
    return (
      <TreeItem key={node.NodeId} nodeId={node.NodeId} label={translateString(node.NodeText)}>
        {node.ChildNodes.map((child) => renderTreeItems(child))}
      </TreeItem>
    );
  }

  return (
    <TreeView onNodeSelect={handleSelect} onNodeToggle={handleExpandedNodes} expanded={expanded}>
      {repositoryChildNodes.map(renderTreeItems)}
    </TreeView>
  );
};

export default withTranslation(DocumentRepositoryTree);
